// @flow

export const HOME_ROUTE = '/';
export const NEWS_ROUTE = '/news';
export const ABOUT_ROUTE = '/about';
export const EFP_DIR_ROUTE = '/efp-directory';
export const RESOURCES_ROUTE = '/resources';
export const FAQS_ROUTE = '/about';
export const CONTACT_ROUTE = '/contact';
